import _ from "lodash";
import { userHasRight } from "../../../framework";
import { confirm } from "../../controls/confirm";
import { toolTip } from "../../controls/toolTip";
import { alert } from "../../core/alert";
import { ll } from "../../core/ll";
import K_Button from "../templates/K_Button";
import { ComponentOptions, RightLockable } from "./component";
import { TemplateComponent } from "./templateComponent";

export interface DropdownItem {
    label: string;
    id: string;
}

export interface ButtonOptions extends ComponentOptions {
    label: string;
    workingText?: string;
    toolTip?: string;
    saveFirstButton?: boolean | "true";
    showBadge?: boolean;
    badgeCount?: string;
    bsc?: string;
    ajaxButton?: boolean | "true";
    confirmHeader?: string;
    confirmMessage?: string;
    okText?: string;
    cancelText?: string;
    finishedText?: string;
    failedText?: string;
    disableOnFinish?: boolean;
    dropdownItems?: DropdownItem[];
    hidden?: boolean;
    requiredRight?: string;
}

export class Button extends TemplateComponent {

    options: ButtonOptions & RightLockable;
    finishedText: string;
    failedText: string;
    disableOnFinish: boolean;
    label: string;
    disabledHandler: any;
    confirmHeaderArgs: any;
    confirmMessageArgs: any;
    confirm: any;
    badge?: any;
    dropdownOpen: boolean;

    constructor(options: ButtonOptions) {
        super(K_Button, options);
    }

    preRender() {
        const options = this.options;

        if (options.requiredRight) {
            options.rightLocked = !userHasRight(options.requiredRight);

            if (options.rightLocked) {
                options.disabled = true;
                options.classes = `${options.classes} right-locked`;
                options.containerClasses = `${options.containerClasses} right-locked`;
            }
        }

        options.badgeCount = options.badgeCount || "";
        options.ajaxButton = options.ajaxButton || !!options.workingText;
        options.toolTip = ll(options.toolTip);

        if (options.ajaxButton) {
            this.finishedText = options.finishedText || "Success";
            this.failedText = options.failedText || "Error!";
            this.disableOnFinish = options.disableOnFinish || false;
            this.label = options.label;
            options.workingText = options.workingText || "Working";
        }
    }

    create() {
        var me = this;
        var button = $("#" + me.id);

        if (me.options.ajaxButton) {
            button.tie("click", function () {
                me.mask();
            });

            button.data("AjaxButton", me);
        }

        if (me.options.saveFirstButton) {
            button.data("Save", function () {
                alert({ header: "No Save Event Registered, please assign the $('#" + button.attr("id") + "').data('me').registerSave(method) method" });
            });

            button.tie("click.InitialTie", function (e) {
                button.data("Save")();
                e.preventDefault();
                e.stopImmediatePropagation();
            });
        }

        if (me.options.toolTip) {
            toolTip({
                selector: $("#" + me.id),
                alignX: "left",
                alignY: "center",
                offsetX: 5
            });
        }

        if (me.options.dropdownItems) {
            let dropdownContent = button.parent().find(".button-dropdown-content"),
                dropdownIcon = button.parent().find(".dropdown-icon");
            dropdownContent.hide();
            me.dropdownOpen = false;

            _.forEach(me.options.dropdownItems, dropdownItem => {
                let item = document.createElement("li");
                item.textContent = ll(dropdownItem.label);
                item.id = me.options.zScreen ? `${me.options.zScreen.id}_${dropdownItem.id}` : dropdownItem.id;
                dropdownContent.append(item);
            });

            button.tie("click", () => {
                dropdownContent.hide();
                me.dropdownOpen = false;
                dropdownIcon.removeClass("fa-caret-up");
                dropdownIcon.addClass("fa-caret-down");
            });

            button.parent().find(".button-dropdown").tie("click", () => {
                if (me.dropdownOpen) {
                    dropdownContent.hide();
                    me.dropdownOpen = false;
                    dropdownIcon.removeClass("fa-caret-up");
                    dropdownIcon.addClass("fa-caret-down");
                } else {
                    dropdownContent.show();
                    me.dropdownOpen = true;
                    dropdownIcon.removeClass("fa-caret-down");
                    dropdownIcon.addClass("fa-caret-up");
                }
            });

            $(window).on("mouseup", () => {
                if (!button.parent().find(".button-dropdown").is(":focus") && me.dropdownOpen) {
                    dropdownContent.hide();
                    me.dropdownOpen = false;
                    dropdownIcon.removeClass("fa-caret-up");
                    dropdownIcon.addClass("fa-caret-down");
                }
            });
        }

        me.badge = $("#" + me.id).find(".badge");
    }

    mask() {
        let me = this,
            button = $("#" + me.id),
            elem = button,
            text = elem.find(".text"),
            spinner = elem.parent().find(".spinner");

        elem.addClass("working").removeClass("failed successful");
        elem.data("kendoTooltip") && elem.data("kendoTooltip").destroy();
        text.text(ll(me.options.workingText));
        spinner.css({ "display": "inline-block" }).animate({
            "opacity": "1",
            "margin-left": "0px",
        }, 500);

        if (me.options.dropdownItems) {
            elem.parent().find(".dropdown-icon").hide();
            elem.parent().find(".button-dropdown").disable();
        } else {
            elem.animate({ "padding-right": "20px" }, 500);
        }

        me.disabledHandler = $.Deferred();
        me.disabledHandler.then(function () {
            elem.disableAll(true);
        });

        $.wait(0).then(function () {
            me.disabledHandler.resolve();
        });
    }

    /**
     * Perform a save invoked by the button click
     * @param args Methods and arguments to do the save
     *              saveMethod      - how to save
     *               - zScreen      - the object on which to invoke saveMethod
     *               - argsArray    - arguments for saveMethod
     *              afterSaveMethod - what to do after the save has completed
     */
    registerSave(args) {
        var me = this;
        var button = $("#" + me.id);

        button.off("click.InitialTie");
        button.data("Save", function (evt) {
            var deferred = args.saveMethod.apply(args.zScreen, args.argsArray);
            var ajaxButton = button.data("AjaxButton");

            if (deferred) {
                deferred.done(function () {
                    var asDeferred = args.afterSaveMethod(evt);

                    if (asDeferred) {
                        asDeferred.done(function (e) {
                            ajaxButton.afterSaveDeferred.resolve(e);
                        });

                        asDeferred.fail(function (e) {
                            ajaxButton.afterSaveDeferred.reject(e);
                        });
                    }
                });

                deferred.fail(function (e) {
                    if (ajaxButton.afterSaveDeferred) {
                        ajaxButton.afterSaveDeferred.reject(e);
                    }
                    ajaxButton.buttonFail({ buttonObj: ajaxButton });
                });
            }
        });

        button.tie("click", function (e) {
            if (me.options.confirmHeader) {
                var header = ll(me.options.confirmHeader);
                var message = ll(me.options.confirmMessage);

                if (me.confirmHeaderArgs) {
                    var headerArgs = me.confirmHeaderArgs;

                    if ($.isFunction(me.confirmHeaderArgs)) {
                        headerArgs = me.confirmHeaderArgs();
                    }
                    header = header.format.apply(header, headerArgs);
                }

                if (me.confirmMessageArgs) {
                    var messageArgs = me.confirmMessageArgs;

                    if ($.isFunction(me.confirmMessageArgs)) {
                        messageArgs = me.confirmMessageArgs();
                    }

                    message = message.format.apply(message, messageArgs);
                }

                var myConfirm = me.confirm = confirm({
                    title: header,
                    message: message,
                    okText: me.options.okText,
                    okClick: function (okE) {
                        if (me.options.ajaxButton) {
                            okE.preventDefault();
                            myConfirm.window.wrapper.mask();

                            button.data("AjaxButton").afterSaveDeferred = $.Deferred();

                            button.data("AjaxButton").afterSaveDeferred.always(function () {
                                myConfirm.window.close();
                            });
                        }

                        myConfirm.clickedOk = true;
                        button.data("Save")(e);
                    },
                    cancelText: me.options.cancelText,
                    cancelClick: function () {
                        if (me.options.ajaxButton && !myConfirm.clickedOk) {
                            button.data("AjaxButton").buttonRevert();
                        }
                    }
                });
            } else {
                button.data("Save")(e);
            }
        });
    }

    setConfirmMessageArgs(args) {
        var me = this;

        me.confirmHeaderArgs = args.headerArgs;
        me.confirmMessageArgs = args.messageArgs;
    }

    /*
    * buttonSuccess
    * Function to call once a button has successfully finished an ajax call
    * OR
    * successfully finished work on the page
    *
    * buttonObj - object send to Button
    * message - Message to display in tool tip
    *
    */
    buttonSuccess(args) {
        args.success = true;
        this.buttonToggle(args);
    }

    /*
    * buttonRevert
    * Function to call once a button's action is cancelled        *
    * buttonElem - button element as control
    *
    */
    buttonRevert() {
        var me = this;
        var buttonObj = this;
        var button = $("#" + this.id);
        var text = button.find(".text");

        button.enableAll(true);
        button.parent().find(".spinner").hide();
        button.stop().removeClass("working");
        button.removeClass("failed");
        button.removeClass("successful");
        button.removeAttr("title");
        if (button.data("kendoTooltip")) {
            button.data("kendoTooltip").destroy();
        }
        if (me.options.dropdownItems) {
            button.parent().find(".dropdown-icon").show();
            button.parent().find(".button-dropdown").enable();
        } else {
            button.css({ "padding-right": "" });
        }

        text.text(ll(buttonObj.label));
    }

    /*
    * buttonFail
    * Function to call once a button has failed to finished an ajax call
    * OR
    * successfully failed to finished work on the page
    *
    * buttonObj - object send to Button
    * message - Message to display in tool tip
    *
    */
    buttonFail(args) {
        args.success = false;
        this.buttonToggle(args);
    }

    buttonToggle(args) {
        var me = this;

        var buttonObj = args.buttonObj;
        var button = $("#" + buttonObj.id);
        var message = args.message;
        var text = button.find(".text");
        var spinner = button.parent().find(".spinner");
        var success = args.success;

        buttonObj.wait && buttonObj.wait.reject && buttonObj.wait.reject();

        button.stop();
        button.removeClass("working");

        if (me.options.dropdownItems) {
            button.parent().find(".dropdown-icon").show();
            button.parent().find(".button-dropdown").enable();
        } else {
            button.css({ "padding-right": "0" });
        }

        button.removeAttr("disabled");

        me.disabledHandler && me.disabledHandler.then(function () {
            button.enableAll(true);
        });

        var prevTitle = button.attr("title");

        button.attr("title", message);

        if (!prevTitle) {
            button.kendoTooltip({
                animation: false,
                position: "left"
            });
        }

        spinner.css({
            "opacity": "0",
            "margin-left": "20px",
        }).hide();

        if (success) {
            button.addClass("successful");
            text.text(buttonObj.finishedText);
            buttonObj.wait = $.wait(3000).done(function () {
                button.css({ "background-color": "" });
                if (buttonObj.disableOnFinish) {
                    button.attr("disabled");
                }
                if (!prevTitle) {
                    button.kendoTooltip({
                        animation: false,
                        position: "left"
                    });
                }
                text.text(ll(buttonObj.label));

                buttonObj.wait = $.wait(5000).done(function () {
                    button.removeClass("successful");
                    button.css({ "padding-right": "" });
                    button.removeAttr("title");
                    if (prevTitle) {
                        button.attr("title", prevTitle);
                    }
                    if (button.data("kendoTooltip")) {
                        button.data("kendoTooltip").destroy();
                    }
                });

            });
        } else {
            text.text(buttonObj.failedText);
            button.addClass("failed");
            buttonObj.wait = $.wait(3000).done(function () {
                button.css({ "background-color": "" });
                text.text(ll(buttonObj.label));

                buttonObj.wait = $.wait(5000).done(function () {
                    button.removeClass("failed");
                    button.css({ "padding-right": "" });
                });
            });
        }
    }

    setButtonBadgeValue(value) {
        var me = this;

        me.badge.html(value).show();
    }

    showButtonBadgeSpinner() {
        this.setButtonBadgeValue("<i class='fas fa-circle-notch fa-spin'></i>");
    }

    enable() {
        let me = this,
            buttonQuery = $("#" + me.id).parent().find("button");

        buttonQuery.enable(true);
        buttonQuery.removeClass("disabled");
    }

    disable() {
        let me = this,
            buttonQuery = $("#" + me.id).parent().find("button");

        buttonQuery.disable(true);
        buttonQuery.addClass("disabled");
    }

    hide() {
        let me = this,
            container = $("#" + me.id).parent();

        container.addClass("hidden");
    }

    show() {
        let me = this,
            container = $("#" + me.id).parent();

        container.removeClass("hidden");
    }

    showWarning(warningToolTip?: string) {
        let me = this,
            button = $(`#${me.id}`);

        if (warningToolTip) {
            button.attr("title", ll(warningToolTip));

            toolTip({
                selector: $("#" + me.id),
                alignX: "left",
                alignY: "center",
                offsetX: 5
            });
        }

        button.addClass("button-warning");
    }

    hideWarning() {
        let me = this,
            button = $(`#${me.id}`);

        if (me.options.toolTip) {
            button.attr("title", ll(me.options.toolTip));
        } else {
            button.removeAttr("title");

            toolTip({
                selector: $("#" + me.id),
                destroy: true
            });
        }

        button.removeClass("button-warning");
    }
}
